import { render, staticRenderFns } from "./AcademicStatusesGrid.vue?vue&type=template&id=618ae0b6"
import script from "./AcademicStatusesGrid.vue?vue&type=script&lang=js"
export * from "./AcademicStatusesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports